// extracted by mini-css-extract-plugin
export var locationCard = "_ib-0";